import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Billing() {
  const [plans, setPlans] = useState([]);
  const [me, setMe] = useState({ plan: "starter" });
  useEffect(() => {
    api.get("/billing/plans").then((r) => setPlans(r.data)).catch(() => {});
    api.get("/billing/me").then((r) => setMe(r.data)).catch(() => {});
  }, []);

  return (
    <Layout>
      <div className="mx-auto max-w-5xl px-6 py-10 sm:px-10">
        <h1 className="font-display text-4xl font-bold tracking-tight">Billing</h1>
        <p className="mt-2 text-muted-foreground">Simple plans. No surprises. You're on the <span className="font-semibold capitalize text-foreground">{me.plan}</span> plan.</p>

        <div className="mt-8 grid gap-4 md:grid-cols-3">
          {plans.map((plan, i) => {
            const current = plan.id === me.plan;
            return (
              <motion.div key={plan.id} initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.08 }}
                className={`rounded-3xl border p-8 ${current ? "border-foreground bg-primary text-primary-foreground" : "border-border bg-card"}`}
                data-testid={`plan-${plan.id}`}>
                <p className="font-display text-xl font-medium">{plan.name}</p>
                <p className="mt-2 font-display text-4xl font-bold">${plan.price}<span className={`text-base font-normal ${current ? "text-primary-foreground/60" : "text-muted-foreground"}`}>/mo</span></p>
                <ul className="mt-6 space-y-2 text-sm">
                  {plan.features.map((f) => (
                    <li key={f} className="flex items-center gap-2"><CheckCircle size={16} weight="fill" className={current ? "text-primary-foreground" : "text-success-foreground"} /> {f}</li>
                  ))}
                </ul>
                <Button
                  variant={current ? "secondary" : "default"}
                  disabled={current}
                  onClick={() => toast.info("Payments aren't connected in this environment yet.")}
                  className="mt-8 w-full rounded-full active:scale-95" data-testid={`select-plan-${plan.id}`}>
                  {current ? "Current plan" : "Choose plan"}
                </Button>
              </motion.div>
            );
          })}
        </div>
        <p className="mt-6 text-xs text-muted-foreground">Payment processing is not connected in this environment. Plan selection is illustrative.</p>
      </div>
    </Layout>
  );
}
